var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 234,
    fill: "white",
    stroke: "white",
    strokeWidth: 32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.234,
    y: 136.088,
    width: 238.278,
    height: 221.606,
    rx: 25.0088,
    fill: "#FEF4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.194 339.245C110.802 337.508 112.123 335.855 113.904 335.855H384.824C386.896 335.855 388.239 338.042 387.303 339.89L376.924 360.374C376.448 361.313 375.483 361.903 374.431 361.897L118.197 360.529C116.904 360.522 115.786 359.623 115.501 358.361L111.194 339.245Z",
    fill: "#FEF4E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.531 309.674C130.531 309.674 130.533 176.339 130.531 159.823C130.53 143.308 136.67 135.762 154.593 135.762C172.516 135.762 316.414 135.762 337.65 135.762C358.886 135.762 368.317 143.782 368.317 159.823C368.317 175.865 368.317 309.674 368.317 309.674",
    stroke: "black",
    strokeWidth: 15.9811,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.678 334.261C186.678 334.261 131.951 334.262 114.965 334.261C97.9785 334.259 116.856 364.927 127.703 364.928C138.551 364.928 348.5 364.928 360.771 364.928C373.041 364.928 401.341 334.26 388.607 334.261C375.872 334.261 309.345 334.261 309.345 334.261",
    stroke: "black",
    strokeWidth: 16.9799,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.102 334.191L287.649 334.191",
    stroke: "black",
    strokeWidth: 16.9799
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.891 294.954V251.883",
    stroke: "#4045A1",
    strokeWidth: 33.345,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.109 294.954V207.423",
    stroke: "#4045A1",
    strokeWidth: 33.345,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M313.648 294.954V233.127",
    stroke: "#4045A1",
    strokeWidth: 33.345,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.38c10b52556257ecc76f6a71460037b4.svg";
export { ForwardRef as ReactComponent };